module.exports = __webpack_public_path__ + "static/media/04_pre-enrollment-contribution.cfda8911.svg";